function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.53418,
  y: 0.943848,
  width: 50.1455,
  height: 50.1455,
  rx: 6,
  fill: "#A4A4A4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1589 26.0166C29.8865 26.0166 25.6074 30.2957 25.6074 35.5681C25.6074 40.8406 29.8865 45.1196 35.1589 45.1196C40.4314 45.1196 44.7105 40.8406 44.7105 35.5681C44.7105 30.2957 40.4314 26.0166 35.1589 26.0166ZM33.2486 40.3439L28.4729 35.5681L29.8196 34.2214L33.2486 37.6408L40.4982 30.3912L41.845 31.7475L33.2486 40.3439Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2787 28.0639L25.8899 22.6406H24.8833L22.3008 25.2397V26.2527L27.6896 31.676C28.0861 32.075 28.7267 32.075 29.1232 31.676L31.2787 29.5067C31.6753 29.1178 31.6753 28.463 31.2787 28.0639Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.8763 19.8988L28.31 18.456L30.4655 20.6253C31.6551 19.4281 31.6551 17.484 30.4655 16.2867L26.8662 12.6644L25.4325 14.1072V11.2216L24.7208 10.4951L21.1215 14.1174L21.8434 14.844H24.7208L23.2872 16.2867L24.3649 17.3714L21.4265 20.3286L17.2273 16.1026V14.6495L14.1567 11.5593L11.2793 14.4551L14.3601 17.5556H15.7937L19.9929 21.7816L19.1287 22.6514H16.9731L11.5843 28.0747C11.1878 28.4737 11.1878 29.1184 11.5843 29.5174L13.7398 31.6867C14.1364 32.0858 14.7769 32.0858 15.1735 31.6867L20.5623 26.2635V24.0942L25.7986 18.8244L26.8763 19.8988Z",
  fill: "white"
});

function SvgGroup832(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup832);
export default __webpack_public_path__ + "static/media/group832.96e39a0d96dd596d214354c6887638df.svg";
export { ForwardRef as ReactComponent };